import { render, staticRenderFns } from "./ConfiguracionSeguridad.vue?vue&type=template&id=3036ded0&scoped=true&lang=pug"
import script from "./ConfiguracionSeguridad.vue?vue&type=script&lang=js"
export * from "./ConfiguracionSeguridad.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionSeguridad.vue?vue&type=style&index=0&id=3036ded0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036ded0",
  null
  
)

export default component.exports